import React, { createContext, useContext, useState, useEffect } from 'react'
import { auth } from '.././firebaseConfig'
import { CircularProgress } from '@material-ui/core'
import classes from './auth.module.css'

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
}

export function AuthProvider(props) {
    const [currentUser, setCurrentUser] = useState({});
    const [loggedIn, setLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const data = localStorage.getItem('loggedIn');
        setLoggedIn(JSON.parse(data));



    }, [])
    useEffect(() => {
        localStorage.setItem('loggedIn', JSON.stringify(loggedIn))

    })






    function signup(email, password) {

        return auth.createUserWithEmailAndPassword(email, password);
    }
    function logIn(email, password) {

        return auth.signInWithEmailAndPassword(email, password);
    }
    function logOut() {
        return auth.signOut();
    }
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {

            setCurrentUser(user)
            setLoading(false);



        })
        return unsubscribe;
    }, [])
    const value = {
        currentUser,
        signup,
        loggedIn,
        setLoggedIn,
        logIn,
        logOut,
    }
    if (loading) {
        return <CircularProgress className={classes.prog} />
    }
    return (
        <AuthContext.Provider value={value}>
            {  props.children}
        </AuthContext.Provider>
    )
}
